// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"article-cover_skeleton__6JqDb","container":"article-cover_container__42Muu","image":"article-cover_image__cf5a9"};